/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Bot_Never_2Inputs */

const en_bot_never_2 = /** @type {(inputs: Bot_Never_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fill in or submit forms, or press buy, sign-up or pay buttons.`)
};

const id_bot_never_2 = /** @type {(inputs: Bot_Never_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mengisi atau mengirim formulir, mengklik tombol beli, daftar, atau bayar.`)
};

/**
* | output |
* | --- |
* | "Fill in or submit forms, or press buy, sign-up or pay buttons." |
*
* @param {Bot_Never_2Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const bot_never_2 = /** @type {((inputs?: Bot_Never_2Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bot_Never_2Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_bot_never_2(inputs)
	return en_bot_never_2(inputs)
});